import debounce from 'debounce';
import { $menuOpen, toggleMenu as storeToggleMenu, setLastFocusedElement as storeSetLastFocusedElement } from '../_store.js';
class SectionHeader extends HTMLElement {
  constructor() {
    super();
    // elements
    this.burgerSelector = '.js-header__burger';
  }
  connectedCallback() {
    // props
    this.scrolled = 0;
    // binding
    this.bndHandleScroll = this.handleScroll.bind(this);
    this.bndHandleResize = debounce(this.handleScroll.bind(this), 250);
    this.bndToggleMenu = this.toggleMenu.bind(this);
    // events
    window.addEventListener('scroll', this.bndHandleScroll);
    window.addEventListener('resize', this.bndHandleResize);
    this.addEventListener('click', this.bndToggleMenu);
    // store events
    $menuOpen.subscribe(value => {
      this.handleMenu(value);
    });
  }
  disconnectedCallback() {
    window.removeEventListener('scroll', this.bndHandleScroll);
    window.removeEventListener('scroll', this.bndHandleResize);
    this.removeEventListener('click', this.bndToggleMenu);
  }
  handleScroll() {
    // console.log('scrolling', window.scrollY, this.scrolled)
    if (window.scrollY >= 60 && window.scrollY >= this.scrolled) {
      // console.log('scroll -> down')
      this.setAttribute('data-scrolled', 'down');
      this.closest('html').style.setProperty('--height--header', 'var(--height--header-scrolled)');
    } else if (window.scrollY >= 60 && window.scrollY < this.scrolled) {
      // console.log('scroll -> up')
      this.setAttribute('data-scrolled', 'up');
      this.closest('html').style.setProperty('--height--header', 'var(--height--header-scrolled)');
    } else {
      // console.log('scroll -> default')
      this.setAttribute('data-scrolled', 'default');
      this.closest('html').style.setProperty('--height--header', 'var(--height--header-default)');
    }
    this.scrolled = window.scrollY;
  }
  handleMenu(value) {
    const trigger = this.querySelector(this.burgerSelector);
    if (!trigger) return;
    storeSetLastFocusedElement(trigger);
    trigger.setAttribute('aria-expanded', value);
  }
  toggleMenu(e) {
    const trigger = e.target.closest(this.burgerSelector);
    if (!trigger) return;
    storeToggleMenu();
  }
}
customElements.define('section-header', SectionHeader);